import OcrService from "@/services/OcrService.js";

export default {
  namespaced: true,
  state: {
    loading: false,
    designLoading: false,
    campaignDetailsLoading: false,
    errors: null,
    campaignList: [],
    campaignListPagination: null,
    customerDesign: null,
    campaignDetails: null,
    joinCampaignResponse: null
  },
  mutations: {
    SET_LOADING(state, value) {
      state.loading = value;
    },
    SET_DESIGN_LOADING(state, value) {
      state.designLoading = value;
    },
    SET_CAMPAIGN_DETAILS_LOADING(state, value) {
      state.campaignDetailsLoading = value;
    },
    SET_ERRORS(state, errors) {
      state.errors = errors;
    },
    SET_CAMPAIGN_LIST(state, response) {
      state.campaignList = response.campaigns || [];
      state.campaignListPagination = {
        currentPage: response.current_page || 1,
        lastPage:    response.last_page    || 1,
        perPage:     response.per_page     || 10,
        total:       response.total        || 0,
        nextPage:    response.next_page    || null,
        prevPage:    response.prev_page    || null
      };
    },
    SET_CUSTOMER_DESIGN(state, data) {
      state.customerDesign = data;
    },
    SET_CAMPAIGN_DETAILS(state, data) {
      state.campaignDetails = data;
    },
    SET_JOIN_CAMPAIGN_RESPONSE(state, data) {
      state.joinCampaignResponse = data;
    }
  },
  getters: {
    loading:               state => state.loading,
    designLoading:         state => state.designLoading,
    campaignDetailsLoading: state => state.campaignDetailsLoading,
    errors:                state => state.errors,
    campaignList:          state => state.campaignList,
    campaignListPagination: state => state.campaignListPagination,
    customerDesign:        state => state.customerDesign,
    campaignDetails:       state => state.campaignDetails,
    joinCampaignResponse:  state => state.joinCampaignResponse,
    hasCampaigns:          state => state.campaignList.length > 0
  },
  actions: {
    async getMicrositeCampaignList({ commit }, request) {
      commit("SET_LOADING", true);
      try {
        const response = await OcrService.getMicrositeCampaignList(request);
        commit("SET_CAMPAIGN_LIST", response);
        return response;
      } catch (errors) {
        commit("SET_ERRORS", errors);
        throw errors;
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async getCustomerDesign({ commit }, header) {
      commit("SET_DESIGN_LOADING", true);
      try {
        const response = await OcrService.getCustomerDesign(header);
        commit("SET_CUSTOMER_DESIGN", response.data);
      } catch (errors) {
        commit("SET_ERRORS", errors);
      } finally {
        commit("SET_DESIGN_LOADING", false);
      }
    },
    async getCustomerDesignPublic({ commit }, header) {
      commit("SET_DESIGN_LOADING", true);
      try {
        const response = await OcrService.getCustomerDesign(header);
        commit("SET_CUSTOMER_DESIGN", response.data);
      } catch (errors) {
        commit("SET_ERRORS", errors);
      } finally {
        commit("SET_DESIGN_LOADING", false);
      }
    },
    async getCampaignDetails({ commit }, request) {
      commit("SET_CAMPAIGN_DETAILS_LOADING", true);
      try {
        const response = await OcrService.getCampaignDetails(request);
        commit("SET_CAMPAIGN_DETAILS", response.campaign);
        return response;
      } catch (errors) {
        commit("SET_ERRORS", errors);
        throw errors;
      } finally {
        commit("SET_CAMPAIGN_DETAILS_LOADING", false);
      }
    },
    async joinCampaign({ commit }, request) {
      try {
        const response = await OcrService.joinCampaign(request);
        commit("SET_JOIN_CAMPAIGN_RESPONSE", response);
        return response;
      } catch (errors) {
        commit("SET_ERRORS", errors);
      }
    }
  }
};
